import { withSvgIcon } from './withSvgIcon';

export const SupportIcon = withSvgIcon(
  <>
    <path d="M5 18V11C5 7.13401 8.13401 4 12 4C15.866 4 19 7.13401 19 11V18" stroke="currentColor" strokeWidth="1.5" />
    <path d="M9.5 20.5H14.5" stroke="currentColor" strokeWidth="1.5" />
    <path d="M7.5 12V18" stroke="currentColor" strokeWidth="1.5" />
    <path d="M16.5 12V18" stroke="currentColor" strokeWidth="1.5" />
  </>,
  { viewBox: '0 0 24 24' },
);
